export const IMAGE_EXT_REGEX = /\.(jpeg|jpg|gif|png)$/;
export const YOUTUBE_REGEX = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/;
export const YOUTUBE_EMBED_URL_PARTIAL = 'https://www.youtube.com/embed/';
export const SITE_TITLE = 'FightCamp | Blog';
export const SITE_DESCRIPTION = 'FightCamp is your ultimate resource for boxing and kickboxing workouts, wellness tips, equipment reviews, and fight news.';
export const SITE_THUMBNAIL = 'https://a.storyblok.com/f/115220/1251x626/874f99126e/blog-meta-header-image.png';
export const SITE_COPYRIGHT = `Copyright © FightCamp 2017-${new Date().getFullYear()}, Hykso, Inc. All rights reserved.`;
